export default function galleryWidget(editor) {
  editor.DomComponents.addType('eb-gallery', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-gallery'
    },
    model: {
      defaults: {
        name: 'Gallery',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-gallery', 'data-columns': '3' },
        style: {
          'display': 'grid',
          'grid-template-columns': 'repeat(3, 1fr)',
          'gap': '10px',
          'padding': '10px',
        },
        components: `
          <div style="position:relative;overflow:hidden;border-radius:6px;aspect-ratio:1;background:#e0e0e0;">
            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMzAwIDMwMCI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNlMGUwZTAiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5Ij5JbWFnZSAxPC90ZXh0Pjwvc3ZnPg==" alt="Gallery 1" style="width:100%;height:100%;object-fit:cover;" />
          </div>
          <div style="position:relative;overflow:hidden;border-radius:6px;aspect-ratio:1;background:#e0e0e0;">
            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMzAwIDMwMCI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNkNWQ1ZDUiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5Ij5JbWFnZSAyPC90ZXh0Pjwvc3ZnPg==" alt="Gallery 2" style="width:100%;height:100%;object-fit:cover;" />
          </div>
          <div style="position:relative;overflow:hidden;border-radius:6px;aspect-ratio:1;background:#e0e0e0;">
            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMzAwIDMwMCI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNjYWNhY2EiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5Ij5JbWFnZSAzPC90ZXh0Pjwvc3ZnPg==" alt="Gallery 3" style="width:100%;height:100%;object-fit:cover;" />
          </div>
          <div style="position:relative;overflow:hidden;border-radius:6px;aspect-ratio:1;background:#e0e0e0;">
            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMzAwIDMwMCI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNiZmJmYmYiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5Ij5JbWFnZSA0PC90ZXh0Pjwvc3ZnPg==" alt="Gallery 4" style="width:100%;height:100%;object-fit:cover;" />
          </div>
          <div style="position:relative;overflow:hidden;border-radius:6px;aspect-ratio:1;background:#e0e0e0;">
            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMzAwIDMwMCI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNiNWI1YjUiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5Ij5JbWFnZSA1PC90ZXh0Pjwvc3ZnPg==" alt="Gallery 5" style="width:100%;height:100%;object-fit:cover;" />
          </div>
          <div style="position:relative;overflow:hidden;border-radius:6px;aspect-ratio:1;background:#e0e0e0;">
            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMzAwIDMwMCI+PHJlY3Qgd2lkdGg9IjMwMCIgaGVpZ2h0PSIzMDAiIGZpbGw9IiNhYWFhYWEiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZG9taW5hbnQtYmFzZWxpbmU9Im1pZGRsZSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjE0IiBmaWxsPSIjOTk5Ij5JbWFnZSA2PC90ZXh0Pjwvc3ZnPg==" alt="Gallery 6" style="width:100%;height:100%;object-fit:cover;" />
          </div>
        `,
        traits: [
          { type: 'select', name: 'data-columns', label: 'Columns', changeProp: true, options: [
            { id: '2', label: '2 Columns' },
            { id: '3', label: '3 Columns' },
            { id: '4', label: '4 Columns' },
          ]},
          { type: 'number', name: 'data-gap', label: 'Gap (px)', default: 10 },
        ],
      },
      init() {
        this.on('change:attributes:data-columns', this.updateGrid)
      },
      updateGrid() {
        const cols = this.getAttributes()['data-columns'] || '3'
        this.setStyle({
          ...this.getStyle(),
          'grid-template-columns': `repeat(${cols}, 1fr)`,
        })
      },
    },
  })

  editor.BlockManager.add('eb-gallery', {
    label: 'Gallery',
    category: 'Pro',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M20,4H16.83L15,2H9L7.17,4H4A2,2 0 0,0 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6A2,2 0 0,0 20,4M12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z"/></svg>',
    content: { type: 'eb-gallery' },
  })
}
